// extracted by mini-css-extract-plugin
module.exports = {"pickContainer2":"TicketsV1_pickContainer2__2MYxv","breadContain":"TicketsV1_breadContain__1TEj-","price":"TicketsV1_price__2sRYk","page":"TicketsV1_page__14GBb"};